import { useActiveOrganization } from "@hooks/useActiveOrganization";
import {
    OrganizationAvatar,
    type OrganizationAvatarProps,
} from "./OrganizationAvatar";

const NO_ORGANIZATION: OrganizationAvatarProps["organization"] = {
    name: "Kick",
    logoUrl: null,
};

/**
 * The logo of the organization in scope. Outside an organization it shows
 * the Kick logo.
 */
export const ActiveOrganizationAvatar = (
    props: Readonly<Omit<OrganizationAvatarProps, "organization">>,
) => {
    const activeOrganization = useActiveOrganization();

    return (
        <OrganizationAvatar
            organization={activeOrganization ?? NO_ORGANIZATION}
            {...props}
        />
    );
};
